<template>
    <v-container v-if="evento_id" >
        <DeslindeFiltros @updateFilter="updateFilters" />
        <DeslindesTabla :evento_id="evento_id" :filters="filters" ref="deslindesTabla" @validarFirma="openValidarFirma" />
        <DeslindeDialog v-if="signatureToValidate" :evento_id="evento_id" ref="deslindesDialog" @reloadDeslindes="reloadDeslindes" @close="closeDialog"/>
    </v-container>
</template>
<script>
import DeslindeDialog from './components/DeslindeDialog.vue';
import DeslindesTabla from './components/DeslindesTabla.vue'; 
import DeslindeFiltros from './components/DeslindeFiltros.vue';
export default {
    data() {
        return { 
            evento_id: null, 
            signatureToValidate: null,
        }   
    },
    mounted() {
        this.evento_id = this.$route.params.id;
    },
    methods: {
        closeDialog() {
            this.signatureToValidate = null;
        },
        openValidarFirma(signature) {
            this.signatureToValidate = signature; 
            this.$nextTick(() => {
                this.$refs.deslindesDialog.openValidarFirma(signature);
            });
        },
        reloadDeslindes() {
            this.$refs.deslindesTabla.loadData();
        },
        updateFilters(filters) {
            this.$refs.deslindesTabla.applyFilters(filters);
        }
    },
    components: {
        DeslindesTabla, DeslindeDialog, DeslindeFiltros 
    }
}
</script>